import React, { useContext } from 'react';
import { AuthContext } from 'contexts/AuthContext';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';

const App = () => {
  const { user } = useContext(AuthContext);
  const titulo = 'Olá, ' + user?.nome;

  return (
    <Container>
      <Header titulo={titulo} />
      {/* <Card></Card> */}
    </Container>
  );
};

export default App;
